!function (name, context, definition) {
    if (typeof module != 'undefined' && module.exports) module.exports = definition();
    else if (typeof define == 'function' && define.amd) define(definition);
    else context[name] = definition();
}('processDataEmoji', this, function () {

    // 处理 data 中的 emoji 字符
    function processDataEmoji(next) {
        var that = this;
        var options = this.options;
        var params = this.params;
        var hasEmoji = false;

        // 字符串时,转换 Emoji 成 UTF16
        // http://stackoverflow.com/questions/36673959/how-to-convert-string-with-emoji-%EF%B8%8F-convert-emoji-to-string-like-this-url-wit
        function _process(data) {
            if (typeof data === 'object') {
                data = JSON.stringify(data);
            }
            if (typeof data === 'string') {
                return data.replace(/([\ud83a-\ud83f][\u0000-\uffff])/g, function ($) {
                    hasEmoji = true;
                    return "\\u" + $.charCodeAt(0).toString(16) + "\\u" + $.charCodeAt(1).toString(16);
                });
            } else {
                return data;
            }
        }

        params.data && (params.data = _process(params.data));
        // lib-mtop-open 的 data 处理
        that.sendData && (that.sendData = _process(that.sendData));

        return next().then(function () {
            var retJson = options.retJson;
            var ret = retJson.ret;

            if (ret instanceof Array) {
                ret = ret.join(',');
            }

            // 验签失败时且含有 Emoji 时重试
            if (hasEmoji && ret.indexOf('FAIL_SYS_ILLEGAL_ACCESS') > -1) {
                // TODO retry
                return that.__sequence([
                    that.__processToken,
                    that.__processRequestUrl,
                    that.middlewares,
                    that.__processRequest
                ]);
            }
        });
    }

    return processDataEmoji;
});